export default "__VITE_ASSET__BpJPYs0R__"